import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../../media';

export const modalContentItemStyles = css`
	& + & {
		margin-top: 16px;
	}
`;
export const modalTitleStyles = css`
	padding-left: 16px;
	padding-right: 16px;
`;
export const modalFooterStyles = css`
	${breakpoints.only.smMobile} {
		margin-top: 16px;
		margin-bottom: 16px;
	}
`;
export const modalHeaderSmMobileStyles = css`
	margin-bottom: 16px;

	${breakpoints.from.mobile} {
		display: none;
	}
`;
export const modalHeaderStyles = css`
	${breakpoints.only.smMobile} {
		display: none;
	}
`;
export const modalIconStyles = css`
	display: flex;
	justify-content: center;
	margin-top: 48px;
	margin-bottom: 24px;

	svg {
		width: 220px;
		height: 140px;
	}
`;
export const BrandAttributesSection = styled.section`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	width: 100%;
	margin-top: 24px;
	column-gap: 24px;

	${breakpoints.to.desktop} {
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(2, 1fr);
		column-gap: 16px;
		row-gap: 6px;
	}

	${breakpoints.to.tablet} {
		gap: 12px;
	}

	${breakpoints.only.xSmMobile} {
		grid-template-columns: 1fr;
		grid-template-rows: repeat(4, 1fr);
		row-gap: 12px;
	}
`;
export const BrandAttributeContainer = styled.a`
	height: 152px;
	padding: 22px 20px;
	background-color: var(--background-secondary);
	border-radius: 4px;
	transition: background-color 0.2s;

	&:hover {
		background-color: var(--control-minor);
		cursor: pointer;
	}

	${breakpoints.only.desktop} {
		padding: 22px 0 20px 22px;
	}

	${breakpoints.to.tablet} {
		height: 176px;
	}
`;
export const BrandAttributeText = styled.div`
	display: flex;
	height: 48px;
	margin-top: 24px;
	white-space: break-spaces;
`;
export const BrandAttributeTextChevron = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 34px;
	min-height: 34px;
	margin-left: auto;

	${breakpoints.to.tablet} {
		display: none;
	}
`;
export const BrandAttributeModal = styled.div`
	position: absolute;

	&:empty {
		display: none;
	}
`;
